<template>
  <div>
    <div>
      <TopBar :msg="titName" :pageNum="backNum"></TopBar>
    </div>
    <div class="searchBox">
      <input
        type="text"
        v-model="searchTime"
        readonly
        @click="dateShow = true"
      />
      <img
        src="../../assets/clear.png"
        v-show="searchTime !== ''"
        class="clearBtn"
        @click="clearDate()"
      />
      <img src="../../assets/search.png" @click="search()" />
      <img src="../../assets/mChoose.png" @click="showPopup()" />
    </div>
    <van-calendar
      :min-date="minDate"
      type="range"
      v-model="dateShow"
      @confirm="onConfirm"
    />
    <div class="searchBoxH"></div>
    <van-popup
      class="moreChoose"
      :overlay="false"
      v-model="show"
      position="top"
    >
      <div>
        <div class="mTxtBox">
          <input
            type="text"
            v-model="cReturnGoodsNo"
            class="chooseText"
            placeholder="根据退货单号寻找"
          />
        </div>
        <div class="upHide" @click="hideChoose()">
          收起<img src="../../assets/hide.png" />
        </div>
      </div>
    </van-popup>
    <van-empty description="" v-if="list.length == 0" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        class="scanList"
        v-for="item in list"
        :key="item.cSalesNo"
        @click="linkToDetail(item.id, item)"
      >
        <div class="listTop">
          <div class="">退货单号：{{ item.cReturnGoodsNo }}</div>
          <img src="../../assets/detail.png" />
        </div>
        <div class="listBottom">
          <div class="listBottomLine">
            <p>客户名称：</p>
            <p>{{ item.cInCustomerName }}</p>
          </div>
          <div class="listBottomLine">
            <p>退货数量：</p>
            <p>{{ item.fTotalReturnGoodsCount }}</p>
          </div>
          <div class="listBottomLine">
            <p>退货时间：</p>
            <p>{{ item.tCreateDate.replace(/T/, " ").split(".")[0] }}</p>
          </div>
            <div class="listBottomLine">
            <p>退货备注：</p>
            <p>{{ item.cRemark }}</p>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
// @ is an alias to /src
import { Button, List, Cell, Toast, Empty, Popup, Calendar } from "vant";
import TopBar from "../../components/TopBar";

export default {
  data() {
    return {
      titName: "退货日志",
      backNum: -1,
      list: new Array(),
      loading: false,
      finished: false,
      num: 1,
      cReturnGoodsNo: "",
      searchTime: "",
      tBeginCreateDate: "",
      tEndCreateDate: "",
      show: false,
      dateShow: false,
      minDate: new Date(1970, 0, 1),
    };
  },
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Empty.name]: Empty,
    [Popup.name]: Popup,
    [Calendar.name]: Calendar,
    TopBar: TopBar,
  },
  methods: {
    showPopup() {
      this.show = true;
    },
    hideChoose() {
      this.show = false;
    },
    search() {
      this.list = [];
      this.loading = true;
      this.num = 1;
      this.show = false;
      this.onLoad();
    },
    clearDate() {
      this.tBeginCreateDate = "";
      this.tEndCreateDate = "";
      this.searchTime = "";
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.dateShow = false;
      this.tBeginCreateDate = this.formatDate(start);
      this.tEndCreateDate = this.formatDate(end);
      this.searchTime = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    },

    linkToDetail(orderNum, dd) {
      this.$router.push({
        path: "/backRecord/RecordDetail",
        query: { id: orderNum, data: JSON.stringify(dd) },
      });
    },
    onLoad() {
      // 异步更新数据
      var _this = this;
      var dd = {
        ticket: sessionStorage.getItem("ticket"),
        page: _this.num,
        limit: 30,
        cReturnGoodsNo: this.cReturnGoodsNo,
        tBeginCreateDate: this.tBeginCreateDate,
        tEndCreateDate: this.tEndCreateDate,
      };
      this.$get("/api/PhoneAPI/GetDealerReturnGoodsHeader", dd)
        .then((res) => {
          _this.num = _this.num + 1;
          for (var i = 0; i < res.data.length; i++) {
            this.list.push(res.data[i]);
          }
          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (res.data.length == 0) {
            this.finished = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.moreChoose {
  margin-top: 100px;
}
.mTxtBox {
  padding: 10px;
  text-align: left;
}
.upHide {
  font-size: 10px;
  padding: 6px 0;
  border-bottom: 1px solid #dddddd;
}
.upHide img {
  width: 10px;
  margin-left: 6px;
}
.chooseText {
  width: 260px;
  height: 30px;
  border: none;
  box-shadow: 0 0 5px 0 #eee;
  font-size: 12px;
  text-indent: 6px;
  margin: 4px 0;
}

.searchBox {
  height: 50px;
  border-bottom: 1px solid #eee;
  display: flex;
  background: white;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;
  position: fixed;
  top: 44px;
  left: 0;
  width: 355px;
  z-index: 99;
}
.searchBox img {
  width: 28px;
  flex-shrink: 0;
  height: 28px;
  margin-left: 20px;
}
.searchBox input {
  width: 100%;
  height: 30px;
  border: none;
  box-shadow: 0 0 5px 0 #eee;
  font-size: 12px;
  text-indent: 6px;
}
.searchBoxH {
  height: 50px;
}
.scanList {
  margin: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  font-size: 14px;
  padding: 8px;
}
.listTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 0 10px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.listTop img {
  width: 20px;
  height: 20px;
}
.listBottomLine {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}
.listBottomLine div:last-child {
  width: 100px;
  flex-shrink: 0;
  margin-right: 10px;
}
.listBottomLine div:last-child {
  color: #666666;
}
.clearBtn {
  position: absolute;
  width: 16px !important;
  height: 16px !important;
  margin-right: -120px;
}
</style>
